import { SelectElementMapper } from '../../_services/types/commons.type';
import { SharedFunnelDatalayerEvent } from '../../_services/types/datalayer.types';
import {
  BusinessAccidentPayment,
  getBusinessAccidentPaymentLabel,
} from '../../enums/claim/business/business-accident-payment.enum';
import {
  BusinessIncapacityCause,
  getBusinessIncapacityCauseLabel,
} from '../../enums/claim/business/business-incapacity-cause.enum';
import {
  BusinessSalaryType,
  getBusinessSalaryTypeLabel,
} from '../../enums/claim/business/business-salary-type.enum';

export const BUSINESS_HEALTH_BASE_URL = 'ijm';

export const BUSINESS_HEALTH_FUNNEL_EVENT_BASE: SharedFunnelDatalayerEvent = {
  product_category: 'IJM',
  product_name: 'Claim',
  funnel_complete: false,
  get event() {
    return `${this.product_name}_${this.product_category}`;
  },
};

export const BUSINESS_HEALTH_STEPS = {
  EMPLOYEE: {
    url: 'employe',
    step: [3, 1],
    datalayerEvent: {
      ...BUSINESS_HEALTH_FUNNEL_EVENT_BASE,
      funnel_stage: 4,
      stage_name: 'Employee',
    },
  },
  INCAPACITY_DETAILS: {
    url: 'details-incapacite',
    step: [3, 1],
    datalayerEvent: {
      ...BUSINESS_HEALTH_FUNNEL_EVENT_BASE,
      funnel_stage: 5,
      stage_name: 'Details incapacite',
    },
  },
  SALARY: {
    url: 'salaire',
    step: [3, 1],
    datalayerEvent: {
      ...BUSINESS_HEALTH_FUNNEL_EVENT_BASE,
      funnel_stage: 6,
      stage_name: 'Salaire',
    },
  },
  DOCUMENTS: {
    url: 'documents',
    step: [3, 1],
    datalayerEvent: {
      ...BUSINESS_HEALTH_FUNNEL_EVENT_BASE,
      funnel_stage: 7,
      stage_name: 'Documents',
    },
  },
  VALIDATION: {
    url: 'validation',
    step: [4, 1],
    datalayerEvent: {
      ...BUSINESS_HEALTH_FUNNEL_EVENT_BASE,
      funnel_stage: 8,
      stage_name: 'Validation',
    },
  },
} as const;

export const BUSINESS_HEALTH_INCAPACITY_CAUSE_OPTIONS: SelectElementMapper<BusinessIncapacityCause> =
  {
    [BusinessIncapacityCause.ILLNESS]: {
      value: BusinessIncapacityCause.ILLNESS,
      label: getBusinessIncapacityCauseLabel(BusinessIncapacityCause.ILLNESS),
    },
    [BusinessIncapacityCause.ACCIDENT]: {
      value: BusinessIncapacityCause.ACCIDENT,
      label: getBusinessIncapacityCauseLabel(BusinessIncapacityCause.ACCIDENT),
    },
    [BusinessIncapacityCause.MATERNITY]: {
      value: BusinessIncapacityCause.MATERNITY,
      label: getBusinessIncapacityCauseLabel(BusinessIncapacityCause.MATERNITY),
    },
    [BusinessIncapacityCause.OTHER]: {
      value: BusinessIncapacityCause.OTHER,
      label: getBusinessIncapacityCauseLabel(BusinessIncapacityCause.OTHER),
    },
  };

export const BUSINESS_HEALTH_SALARY_TYPE_OPTIONS: SelectElementMapper<BusinessSalaryType> = {
  [BusinessSalaryType.MONTHLY]: {
    value: BusinessSalaryType.MONTHLY,
    label: getBusinessSalaryTypeLabel(BusinessSalaryType.MONTHLY),
  },
  [BusinessSalaryType.HOURLY]: {
    value: BusinessSalaryType.HOURLY,
    label: getBusinessSalaryTypeLabel(BusinessSalaryType.HOURLY),
  },
};

export const BUSINESS_HEALTH_PAYMENT_OPTIONS: SelectElementMapper<BusinessAccidentPayment> = {
  [BusinessAccidentPayment.EMPLOYER]: {
    value: BusinessAccidentPayment.EMPLOYER,
    label: getBusinessAccidentPaymentLabel(BusinessAccidentPayment.EMPLOYER),
  },
  [BusinessAccidentPayment.EMPLOYEE]: {
    value: BusinessAccidentPayment.EMPLOYEE,
    label: getBusinessAccidentPaymentLabel(BusinessAccidentPayment.EMPLOYEE),
  },
};
